import { __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import IframePopup from '../IframePopup';
var ORDER_COMMISSION_MODAL_URL = '/grusers-modals/commissions/purchase';
function getOrderCommissionModalUrl(_a) {
    var author = _a.author, deviationId = _a.deviationId;
    if (!author) {
        return;
    }
    var params = {
        gruserid: author.userId,
        request: JSON.stringify({ commission_id: deviationId }),
    };
    var queryParams = Object.keys(params)
        .map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    })
        .join('&');
    return "" + URLS.ROOT + ORDER_COMMISSION_MODAL_URL + "?" + queryParams;
}
var OrderCommissionPopup = /** @class */ (function (_super) {
    __extends(OrderCommissionPopup, _super);
    function OrderCommissionPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popupRef = React.createRef();
        _this.onMessage = function (_a) {
            var origin = _a.origin, data = _a.data;
            var requestClose = _this.props.requestClose;
            try {
                var _b = JSON.parse(data), type = _b.type, command = _b.command, width = _b.width, height = _b.height;
                if (!type || type !== 'PurchaseModal') {
                    return;
                }
                switch (command) {
                    case 'close':
                        requestClose();
                        break;
                    case 'resize':
                    case 'error':
                        var iframe = _this.popupRef.current;
                        iframe && iframe.requestResize({ width: width, height: height });
                        break;
                    default:
                    // Do nothing
                }
            }
            catch (_c) {
                return;
            }
        };
        return _this;
    }
    OrderCommissionPopup.prototype.render = function () {
        var _a = this.props, deviation = _a.deviation, t = _a.t;
        return (React.createElement(IframePopup, { title: t('deviation.orderCommission'), initialWidth: 450, initialHeight: 520, src: getOrderCommissionModalUrl(deviation) || '', onMessage: this.onMessage }));
    };
    return OrderCommissionPopup;
}(React.Component));
export { OrderCommissionPopup };
export default withTranslation()(OrderCommissionPopup);
//# sourceMappingURL=OrderCommissionPopup.js.map